'use client'

import { useClientMounted } from '@/hooks/use-client-mounted'
import { PERSISTED_LAYOUT_INIT_SCRIPT } from './persisted-layout-widths'

/**
 * Publishes persisted sidebar/panel widths as CSS variables before first
 * paint, so route skeletons match the operator's layout without reading
 * localStorage during hydration. Same executable-then-inert pattern as
 * LocaleInitScript.
 */
export function PersistedLayoutInitScript() {
  const isClientMounted = useClientMounted()

  return (
    <script type={isClientMounted ? 'application/json' : undefined}>
      {PERSISTED_LAYOUT_INIT_SCRIPT}
    </script>
  )
}
